import { createFileRoute } from '@tanstack/react-router'
import PostsList from '@/components/PostsList'

export const Route = createFileRoute('/posts')({
  component: () => (
    <PostsList
      title="Latest from ScamDefense."
      intro="Plain-English breakdowns of new scam tactics, steps you can take this week, and stories from people who saw it coming."
    />
  ),
})
